module.exports = __webpack_public_path__ + "img/ecological_footprint_button.62d8e49d.png";